
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vault",
      function () {
        return require("private-next-pages/vault.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vault"])
      });
    }
  